import { useMemo } from 'react';

interface IUseContentProps {
  data?: unknown[];
  isLoading?: boolean;
}

export const useContent = ({ data, isLoading }: IUseContentProps) =>
  useMemo(() => {
    const hasChart = !isLoading && data && data.length > 0;
    const hasPlaceholder = !isLoading && !hasChart;

    return { hasChart, hasPlaceholder, hasPreloader: isLoading };
  }, [data, isLoading]);
